namespace distill.datasets.views.createWizard3_schema {
    enum DatasetCreationMethod {
        None = "None",
        Manual = "Manual",
        FormScreen = "FormScreen",
        DataSource = "DataSource",
        FileUpload = "FileUpload"
    }

    class InitArgs {
        wizardToken: string = '';
        creationMethod: DatasetCreationMethod = DatasetCreationMethod.None;
        name: string = '';
        externalId: string = '';
        columns: distill.datasets.views.IColumn[] = [];
        columnTypes: { value: string; text: string }[] = [];
        urls!: {
            navigateToStep: string;
        };
    }

    let _initArgs: InitArgs;
    let _flatColumnBuilder: distill.datasets.views.ColumnBuilder | null = null;

    export function init(args: InitArgs): void {
        _initArgs = args;
        
        distill.datasets.views.setColumnTypes(_initArgs.columnTypes);

        $(function () {
            bindEvents();
            initFlatBuilder(_initArgs.columns);
        });
    }

    function getParentButton(selector: string): JQuery<HTMLElement> {
        return $(parent.document).find(selector) as unknown as JQuery<HTMLElement>;
    }

    function bindEvents(): void {
        getParentButton('#wizardBackBtn').on('click', function (e) {
            e.preventDefault();
            // Server handles where to go back based on flow, but we can also use history.back()
            // However, to be safe with session/cache state, we can also explicit navigate
            // history.back() is preferred for form data preservation
            history.back();
        });

        getParentButton('#wizardCreateBtn').on('click', function () {
            if (validateForm())
                submitForm();
        });

        $('#addColumnBtn').on('click', function () {
            if (_flatColumnBuilder)
                _flatColumnBuilder.addColumn();
            
            appn.iframe.setModalIframeHeight(true);
        });
    }

    function initFlatBuilder(columns: distill.datasets.views.IColumn[]): void {
        const isCruxSource = _initArgs.creationMethod === DatasetCreationMethod.FormScreen || _initArgs.creationMethod === DatasetCreationMethod.DataSource;
        _flatColumnBuilder = new distill.datasets.views.ColumnBuilder(columns, {
            isCruxSource: isCruxSource,
            isCreateMode: true,
            containerId: 'schemaColumnsList',
            showPk: !isCruxSource,
            showType: true,
            showRequired: !isCruxSource,
            showUnique: !isCruxSource,
            allowTypeChanges: !isCruxSource,
            onChanged: () => distill.datasets.views.ColumnBuilder.refreshIndexes([{ builder: _flatColumnBuilder }])
        });
        distill.datasets.views.ColumnBuilder.refreshIndexes([{ builder: _flatColumnBuilder }]);
    }

    function validateForm(): boolean {
        let isValid = true;
        $('[data-valmsg-for]').text('').addClass('field-validation-valid').removeClass('field-validation-error');

        distill.datasets.views.ColumnBuilder.refreshIndexes([{ builder: _flatColumnBuilder }]);

        const name = $('input[name="Name"]').val()?.toString()?.trim() || '';
        if (!name) {
            $('[data-valmsg-for="Name"]').text(T('Dataset name is required.')).addClass('field-validation-error').removeClass('field-validation-valid');
            isValid = false;
        }

        if (!$('form').valid())
            isValid = false;

        if (!isValid) {
            const $firstError = $('.field-validation-error:visible').first();
            if ($firstError.length)
                $firstError[0].scrollIntoView({ behavior: 'smooth', block: 'center' });
        }

        return isValid;
    }

    function submitForm(): void {
        distill.datasets.views.ColumnBuilder.refreshIndexes([{ builder: _flatColumnBuilder }]);
        ($('form')[0] as HTMLFormElement).submit();
    }
}
